<script>
	import { t } from '$lib/i18n.js';
	import { page } from '$app/stores';
	import { generateStructuredData, getSiteAggregateRating } from '$lib/seo.js';
	import { seoConfig } from '$lib/seo.js';
	import SEOHead from '$lib/components/SEOHead.svelte';
	// onMount not needed here; flags are hydrated globally in root layout
	import Pricing from './components/Pricing.svelte';
	import HowItWorks from './components/how_it_works/HowItWorks.svelte';
	import Header from './components/header/Header.svelte';
	import NavBar from '$lib/components/Navbar.svelte';
	import OwnerSection from '$lib/components/OwnerSection.svelte';
	import BlogSection from '$lib/components/BlogSection.svelte';
	import CarsGrid from './components/cars/CityCarsGrid.svelte';
	import CitiesGrid from './components/cities/CitiesGrid.svelte';
	import AutingValuesSection from './components/auting_values/AutingValuesSection.svelte';
	import MobileAppSection from '$lib/components/MobileAppSection.svelte';

	export let data;

	$: lang = $page.params.lang;
	// Site-wide rating sourced from Trustpilot (see seoConfig.trustpilot).
	$: aggregateRating = getSiteAggregateRating();
	$: structuredData = [
		generateStructuredData('Organization', {}, lang),
		generateStructuredData('WebSite', {}, lang),
		generateStructuredData('Service', {
			name: 'Auting - Peer-to-peer car sharing',
			description: seoConfig.businessDescription[lang],
			url: `https://auting.it/${lang === 'en' ? '' : lang}`,
			...(aggregateRating ? { aggregateRating } : {})
		}, lang),
		generateStructuredData('WebPage', {
			title: $t('routes.home.title'),
			description: seoConfig.defaultDescription[lang],
			url: `https://auting.it/${lang === 'en' ? '' : lang}`
		}, lang)
	];
	
	// Feature flags are hydrated globally; no per-page refresh needed
</script>

<SEOHead 
	title="{$t('routes.home.title')} - Auting"
	description={seoConfig.defaultDescription[lang]}
	keywords={seoConfig.defaultKeywords[lang]}
	structuredData={structuredData}
	pageName="home"
/>

<main>
	<NavBar
		foregroundColor="var(--on-surface)"
		backgroundColor="var(--surface-container)"
		logoAndTextsColor="var(--surface)"
		logoInverted={true}
	/>
	<Header />
	<HowItWorks />
	<Pricing />
	<CarsGrid />
	<CitiesGrid />
	<MobileAppSection />
	<AutingValuesSection />
	<OwnerSection />
	<BlogSection />
</main>

<style>
	.hero {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		text-align: center;
		padding: 4rem 2rem;
		min-height: 60vh;
	}

	.hero-content {
		max-width: 800px;
	}

	h1 {
		font-size: 3rem;
		color: var(--color-theme-1);
		margin: 0 0 1rem 0;
	}

	.subtitle {
		font-size: 1.25rem;
		color: var(--color-text);
		margin: 0 0 1rem 0;
		opacity: 0.8;
	}

	.description {
		font-size: 1rem;
		color: var(--color-text);
		margin: 0 0 2rem 0;
		opacity: 0.7;
	}

	.language-switcher {
		display: flex;
		gap: 1rem;
		justify-content: center;
		margin-top: 2rem;
	}

	.language-switcher a {
		padding: 0.5rem 1rem;
		border: 2px solid var(--color-theme-1);
		border-radius: 4px;
		text-decoration: none;
		color: var(--color-theme-1);
		transition: all 0.2s;
	}

	.language-switcher a:hover,
	.language-switcher a.active {
		background-color: var(--color-theme-1);
		color: white;
	}
</style>